import React from 'react';
import { useNavigate } from 'react-router';

const ServiceSwitcher = ({service, onService}) => {
  
  const services = [['Home','/'],['Synchronize','/sync'], ['Digitization','/ocr'], ['Planner','/planner'], ['Logger','/note'],['About','/home']];
  
  const navigate = useNavigate();
  const selected = services.findIndex(([name, url]) => name === service || url === service);

  const onChange = (event) => {
    if(event.target?.value>=0) {
      let app = services[event.target.value];

      onService(app[0]);
      navigate(app[1]);
    }
  };

  const onMouseLeave = (event) => {
    //alert('mouse leave')
    event.currentTarget.blur();
  };

  return (
    <select onChange={onChange} onMouseLeave={onMouseLeave} id="ServiceSwitcher" className="NavLink Switcher" value={selected >= 0 ? selected : 0}>
      {services.map((app, index) => (
        <option key={app[0]} id={app[0]} value={index}>
          {app[0]}
        </option>
      ))}
    </select>
  );
};

export  {ServiceSwitcher}